export const ITEM_VALUE = 'itemValue';